import React, { useState } from "react";
import {
  Button,
  Label,
  Select,
  SelectOption,
  CloseIcon,
  RadioButton,
  UndoIcon,
  Control,
  Search,
} from "@forge/common";
import "./filter-and-sort.scss";
import { TABLE_HEADING } from "../view-course-templates/utils/constants";
import { btnResponsive, textResponsive } from "../common/utils/helper";
import ButtonComponent from "../common/components/button/button";

interface FilterAndSortProps {
  open: boolean;
  onClose: () => void;
  sortBy: string;
  setSortBy: (value: string) => void;
  setFilterBy: (value: string) => void;
  setFilterSearchText: (value: string) => void;
}

const FilterAndSort: React.FC<FilterAndSortProps> = ({ open, onClose, sortBy, setSortBy, setFilterBy, setFilterSearchText }) => {

  const filterList = [
    { id: 1, label: TABLE_HEADING.COURSE_NAME, checked: false, key: "courseName" },
    { id: 2, label: TABLE_HEADING.COURSE_DESCRIPTION, checked: false, key: "courseDescription" },
  ];

  const [tempSortBy, setTempSortBy] = useState(sortBy);
  const [search, setSearch] = useState("");
  const [selectedFilter, setSelectedFilter] = useState<string>("courseName");
  const [resetKey, setResetKey] = useState(0);

  const handleFilterChange = (name: string) => {
    setSelectedFilter(name);
  };

  const handleClearAll = () => {
    setSortBy("");
    setSelectedFilter("");
    setFilterSearchText("")
    setFilterBy("")
    setTempSortBy("");
    setSearch("");
    setResetKey(prev => prev + 1);
  };

  if (!open) return null;

  const handleCancelModal = () => {
    setSortBy("");
    setFilterSearchText("")
    setTempSortBy("")
    setSearch("");
    setSelectedFilter("courseName");
    setFilterBy("");
    setResetKey(prev => prev + 1);
    onClose();
  }

  const handleShowResults = () => {
    tempSortBy && setSortBy(tempSortBy);
    setFilterBy(selectedFilter);
    setFilterSearchText(search)
    onClose();
  }

  const resultBtndisable = () => {
    let result = true;
    if (tempSortBy !== "" || (selectedFilter !== "" && search !== "")) {
      result = false
    }
    return result;
  }

  return (
    <div className="filter-popover absolute z-50 bg-container-dark rounded shadow-lg mt-2 w-80 xl-low:w-[320px] xl-mid:w-[360px] xl-high:w-[420px] top-8 right-0 pop-left">
      <div className="p-8">
        <div className="flex items-center justify-between">
          <span className={`font-semibold ${textResponsive("text-base")} text-base`}>Filter & sort</span>
          <CloseIcon onClick={handleCancelModal} className="cursor-pointer" data-testid="close-icon" />
        </div>
        <div className="w-[95%]">
          <Control className="select-course">
            <Select
              key={resetKey}
              id="sort-by-select"
              data-testid="sort-by-select"
              defaultValue={tempSortBy}
              placeholder="Sort by"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setTempSortBy(event.target.value)
              }
              className="view-course-select-box !border-none !font-normal"
            >
              <SelectOption
                value={TABLE_HEADING.COURSE_NAME}
                label={TABLE_HEADING.COURSE_NAME}
                data-testid="sort-option-course-name"
              >
                <div
                  id="sort-option-course-name-container"
                  className="flex items-center cursor-pointer"
                  data-testid="sort-option-course-name-radio"
                >
                  <RadioButton
                    id="sort-by-courseName"
                    name="sort-by"
                    data-testid="sort-by-courseName"
                    checked={tempSortBy === TABLE_HEADING.COURSE_NAME}
                    onChange={() => setTempSortBy(TABLE_HEADING.COURSE_NAME)}
                    value={TABLE_HEADING.COURSE_NAME}
                  />
                  <span
                    className={`ml-[6px] xl-high:ml-[12px] xl-high:my-[3px] ${textResponsive("text-sm")} text-sm !font-normal`}
                    data-testid="label-sort-by-name"
                    onClick={() => setTempSortBy(TABLE_HEADING.COURSE_NAME)}
                  >
                    {TABLE_HEADING.COURSE_NAME}
                  </span>
                </div>
              </SelectOption>
              <SelectOption
                value={TABLE_HEADING.LAST_MODIFIED_BY}
                label={TABLE_HEADING.LAST_MODIFIED_BY}
                data-testid="sort-option-last-modified-by"
              >
                <div
                  id="sort-option-last-modified-by-container"
                  className="flex items-center cursor-pointer"
                  data-testid="sort-option-last-modified-by-radio"
                >
                  <RadioButton
                    id="sort-by-lastModifiedBy"
                    name="sort-by"
                    data-testid="sort-by-lastModifiedBy"
                    checked={tempSortBy === TABLE_HEADING.LAST_MODIFIED_BY}
                    onChange={() => setTempSortBy(TABLE_HEADING.LAST_MODIFIED_BY)}
                    value={TABLE_HEADING.LAST_MODIFIED_BY}
                  />
                  <span
                    className={`ml-[6px] xl-high:ml-[12px] xl-high:my-[3px] ${textResponsive("text-sm")} text-sm !font-normal`}
                    data-testid="label-sort-by-last-modified-by"
                    onClick={() => setTempSortBy(TABLE_HEADING.LAST_MODIFIED_BY)}
                  >
                    {TABLE_HEADING.LAST_MODIFIED_BY}
                  </span>
                </div>
              </SelectOption>
              <SelectOption
                value={TABLE_HEADING.LAST_MODIFIED_DATE}
                label={TABLE_HEADING.LAST_MODIFIED_DATE}
                data-testid="sort-option-last-modified-date"
              >
                <div
                  className="flex items-center cursor-pointer"
                  data-testid="sort-option-last-modified-date-radio"
                >
                  <RadioButton
                    id="sort-by-lastModifiedDate"
                    name="sort-by"
                    data-testid="sort-by-lastModifiedDate"
                    checked={tempSortBy === TABLE_HEADING.LAST_MODIFIED_DATE}
                    onChange={() => setTempSortBy(TABLE_HEADING.LAST_MODIFIED_DATE)}
                    value={TABLE_HEADING.LAST_MODIFIED_DATE}
                  />
                  <span
                    className={`ml-[6px] xl-high:ml-[12px] xl-high:my-[3px] ${textResponsive("text-sm")} text-sm !font-normal`}
                    data-testid="label-sort-by-last-modified-date"
                    onClick={() => setTempSortBy(TABLE_HEADING.LAST_MODIFIED_DATE)}
                  >
                    {TABLE_HEADING.LAST_MODIFIED_DATE}
                  </span>
                </div>
              </SelectOption>
            </Select>
          </Control>
        </div>
        <div className="flex justify-between items-center mb-[10px] xl-high:mb-[16px]">
          <div className={`font-semibold ${textResponsive("text-base")} text-base`}>Filter by</div>
          <Button
            icon={<UndoIcon className={`${btnResponsive("text-sm")}`} />}
            iconPosition="left"
            variant="quiet-primary"
            size="regular"
            className={`font-semibold ${btnResponsive()}`}
            onClick={handleClearAll}
          >
            Clear all
          </Button>
        </div>
        <div className="pb-7 w-[95%]">
          <Search
            key={resetKey}
            id="filter-search"
            aria-label="Search"
            debounce={100}
            minCharacters={1}
            className="view-course-search-bar !border-none"
            defaultValue={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            size="regular"
            />
        </div>

        {filterList.map((filter) => (
          <div
            key={filter.id}
            className="mb-2"
            data-testid={`filter-item-${filter.id}`}
          >
            <div className="flex items-center">
              <RadioButton
                id={`filter-radio-${filter.id}`}
                name="filter-radio-group"
                checked={selectedFilter === filter.key}
                onChange={() => handleFilterChange(filter.key)}
                value={filter.key}
              />
              <span
                onClick={() => handleFilterChange(filter.key)}
                className={`xl-high:ml-4 xl-high:my-1 ml-2 cursor-pointer text-base ${textResponsive("text-sm")}`}
                data-testid={`filter-label-${filter.id}`}
              >
                {filter.label}
              </span>
            </div>
          </div>
        ))}
        <div className="flex justify-between gap-2 pt-10 xl-high:pt-6">
          <Button variant="quiet-primary" className={`${btnResponsive()}`} onClick={handleCancelModal}>
            Cancel
          </Button>
          <ButtonComponent
            aria-label="Show Results"
            data-testid="show-results-button"
            className={`text-white show-result-button font-normal rounded bg-blue`}
            onClick={handleShowResults}
            size="regular"
            disabled={resultBtndisable()}
            variant={resultBtndisable() ? "tertiary" : "primary"}
            title={"Show Results"}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterAndSort;